import { author as authorData, authorTypes as authorTypesData } from "shared/data";

export const isSCMPEditorial = (authorIds: string[]) =>
  authorIds?.includes(authorData.scmpEditorial.entityId);

export const isSCMPPR = (authorIds: string[]) => authorIds?.includes(authorData.scmpPR.entityId);

export const isSCMPColumnist = (authorTypes?: null | ReadonlyArray<Nullish<string>>) =>
  authorTypes?.includes(authorTypesData.ScmpColumnist);
